import { ModalType, openModalTask } from '@src/components/modalComponent/modalComponent'

export const PRIVATE_USER_NAME = 'Private player'

export const getUserLink = (uuid: string | null, name: string | null) => {
  if (name === PRIVATE_USER_NAME || null === uuid || undefined === uuid) {
    return name
  }

  return (
    <span className="cursor-pointer" onClick={() => openModalTask.next({ type: ModalType.userProfile, uuid: uuid! })}>
      {name}
    </span>
  )
}

export const getUserAvatar = (userId: string): string => {
  // Convert the userId string to a number using a hash function
  const hash = Array.from(userId)
    .map((char) => char.charCodeAt(0))
    .reduce((acc, code) => (acc << 5) - acc + code, 0)

  // Get absolute value of hash and mod by 8 (number of available avatars)
  const avatarIndex = Math.abs(hash) % 8

  return `https://cdn.blackjack.fun/optimized/avatars/cat${avatarIndex + 1}.webp`
}
